<template>
  <svg :width="size" :height="size" :viewBox="viewBox" :style="rootStyle" :class="rootClass">
    <circle
      :stroke="backgroundColor"
      :stroke-opacity="backgroundOpacity"
      :stroke-width="strokeWidth"
      fill="transparent"
      :r="radius"
      :cx="size / 2"
      :cy="size / 2"
      class="bravado-progress-chart-v2__circle"
    />
    <circle
      :stroke="foregroundColor"
      :stroke-width="strokeWidth"
      :stroke-dasharray="`${circumference} ${circumference}`"
      :stroke-dashoffset="offset"
      stroke-linecap="round"
      fill="transparent"
      :r="radius"
      :cx="size / 2"
      :cy="size / 2"
      class="bravado-progress-chart-v2__circle"
    />
  </svg>
</template>

<script>
const SIZE = 32;
const STROKE_WIDTH = 3;

export default {
  name: 'BravadoProgressChartV2',
  props: {
    percent: {
      default: 0,
      type: Number,
    },
    foregroundColor: {
      type: String,
      default: 'var(--universal-color-gray-50)',
    },
    backgroundColor: {
      type: String,
      default: 'var(--universal-color-gray-50)',
    },
    backgroundOpacity: {
      type: [Number, String],
      default: 0.2,
    },
    strokeWidth: {
      type: Number,
      default: STROKE_WIDTH,
    },
    size: {
      type: Number,
      default: SIZE,
    },
    transitionDuration: {
      type: Number,
      default: 0.5,
    },
    spinner: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    radius() {
      return this.size / 2 - this.strokeWidth;
    },
    viewBox() {
      return `0 0 ${this.size} ${this.size}`;
    },
    circumference() {
      return this.radius * 2 * Math.PI;
    },
    offset() {
      return this.circumference - (this.percent / 100) * this.circumference;
    },
    rootClass() {
      return {
        'bravado-progress-chart-v2': true,
        'bravado-progress-chart-v2--spinner': this.spinner,
      };
    },
    rootStyle() {
      return { '--transition-duration': `${this.transitionDuration}s` };
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.bravado-progress-chart-v2 {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;

  &__circle {
    transition: stroke-dashoffset var(--transition-duration) linear;
  }

  &--spinner {
    animation: rotate 0.7s linear infinite;
  }
}
</style>
